import { ClassData } from "../dtos/classes.type";
import { DEFAULT_CATEGORY } from "../services/default-category.service";
import { URL_PARAMETERS } from "./const.util";
import { getUrlParameterValue } from "./url.util";

export function filterByGender(data: ClassData[]): ClassData[] {
  const gender = getUrlParameterValue(URL_PARAMETERS.GENDER);

  if (gender === "All") {
    return data;
  }

  return data.filter(
    (item) => item?.gender?.toLowerCase() === gender || item.gender === "All"
  );
}

export function filterByKeyAndValue(
  data: ClassData[],
  key: string,
  value: string
): ClassData[] {
  if (
    value?.toLowerCase() === "all" ||
    value?.toLowerCase() === "null" ||
    !value
  ) {
    return data;
  }

  return data.filter(
    (item: any) =>
      item[key]?.toLowerCase() === value ||
      item[key]?.toLowerCase() === "all" ||
      item[key]?.toLowerCase() === "null"
  );
}

export function filterByFullClasses(data: ClassData[]): ClassData[] {
  const hasFullClasses =
    getUrlParameterValue(URL_PARAMETERS.FULL_CLASSES) === "true"; // complete this
  if (!hasFullClasses) {
    return data;
  }

  return data.filter((item) => item?.openings.calculated_openings > 0);
}

export function filterByAge(data: ClassData[]): ClassData[] {
  const age = getUrlParameterValue(URL_PARAMETERS.AGE);
  if (!age) {
    return data;
  }

  const [min_age, max_age] = age.split("-");

  return data.filter((item) => {
    const itemMinAge = convertDurationToMonths(item.min_age);
    const itemMaxAge = convertDurationToMonths(item.max_age);
    const filterMinAge = convertDurationToMonths(min_age);
    const filterMaxAge = convertDurationToMonths(max_age);

    return itemMinAge <= filterMaxAge && itemMaxAge >= filterMinAge;
  });
}

function convertDurationToMonths(duration: string): number {
  const matches = duration.match(/P(\d+)Y(\d+)M/);
  if (!matches) return 0;

  const years = parseInt(matches[1]);
  const months = parseInt(matches[2]);

  return years * 12 + months;
}

export function filterByMultipleValues(
  data: ClassData[],
  list: string
): ClassData[] {
  if (typeof list !== "string" || list.trim() === "") {
    return [];
  }

  const filters = list.split(",").map((item) => item.trim());
  let allData = [];
  for (const index in filters) {
    allData.push(
      ...data.filter((item) => item[DEFAULT_CATEGORY] === filters[index])
    );
  }

  return allData;
}

export function filterByDays(data: ClassData[], list: string): ClassData[] {
  if (typeof list !== "string" || list.trim() === "") {
    return [];
  }

  const filters = list.split(",").map((item) => item.trim());
  let allData = [];
  for (const index in filters) {
    allData.push(
      ...data.filter((item: any) => item.meeting_days?.[`${filters[index]}`])
    );
  }

  return allData;
}

export function filterByLocation(data: ClassData[]): ClassData[] {
  const location = getUrlParameterValue(URL_PARAMETERS.LOCATION);
  return data.filter((item) => item.location_name === location);
}
